(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tmpg-subjects"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-tmpg-carousel]';
    const dragThreshold = 8;

    const maximumScroll = (track) => Math.max(0, track.scrollWidth - track.clientWidth);

    const groupDistance = (track) => {
      const firstCard = track.querySelector('[data-tmpg-carousel-card]');
      if (!firstCard) return track.clientWidth;
      const styles = getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      const cardWidth = firstCard.getBoundingClientRect().width;
      const visibleCards = Math.max(1, Math.floor((track.clientWidth + gap) / (cardWidth + gap)));
      return visibleCards * (cardWidth + gap);
    };

    const moveCarousel = (carousel, direction) => {
      const track = carousel.querySelector('[data-tmpg-carousel-track]');
      if (!track) return;
      const destination = Math.min(
        maximumScroll(track),
        Math.max(0, track.scrollLeft + direction * groupDistance(track))
      );
      track.scrollTo({ left: destination, behavior: 'smooth' });
    };

    const initialise = (carousel) => {
      if (carousel.dataset.tmpgCarouselReady === 'true') return;

      const track = carousel.querySelector('[data-tmpg-carousel-track]');
      const previous = carousel.querySelector('[data-tmpg-carousel-prev]');
      const next = carousel.querySelector('[data-tmpg-carousel-next]');
      const controls = carousel.querySelector('[data-tmpg-carousel-controls]');
      const firstCard = carousel.querySelector('[data-tmpg-carousel-card]');

      if (!track || !previous || !next || !firstCard) return;

      carousel.dataset.tmpgCarouselReady = 'true';
      let animationFrame;
      let pointerId = null;
      let pointerStart = 0;
      let scrollStart = 0;
      let suppressClick = false;

      const updateControls = () => {
        const maximum = maximumScroll(track);
        previous.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= maximum - 1;
        previous.setAttribute('aria-disabled', String(previous.disabled));
        next.setAttribute('aria-disabled', String(next.disabled));
        controls.hidden = maximum <= 1;
      };

      const queueControlUpdate = () => {
        if (animationFrame) cancelAnimationFrame(animationFrame);
        animationFrame = requestAnimationFrame(updateControls);
      };

      track.addEventListener('scroll', queueControlUpdate, { passive: true });

      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        pointerId = event.pointerId;
        pointerStart = event.clientX;
        scrollStart = track.scrollLeft;
        suppressClick = false;
      });

      track.addEventListener('pointermove', (event) => {
        if (event.pointerId !== pointerId) return;
        const distance = event.clientX - pointerStart;
        const destination = Math.min(maximumScroll(track), Math.max(0, scrollStart - distance));
        if (!suppressClick && Math.abs(destination - scrollStart) > dragThreshold) {
          suppressClick = true;
          track.classList.add('is-dragging');
          track.setPointerCapture(pointerId);
        }
        if (suppressClick) track.scrollLeft = destination;
      });

      const finishPointer = (event) => {
        if (event.pointerId !== pointerId) return;
        if (track.hasPointerCapture(pointerId)) track.releasePointerCapture(pointerId);
        pointerId = null;
        track.classList.remove('is-dragging');
      };

      track.addEventListener('pointerup', finishPointer);
      track.addEventListener('pointercancel', finishPointer);
      track.addEventListener('click', (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      }, true);

      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(queueControlUpdate);
        observer.observe(track);
      } else {
        window.addEventListener('resize', queueControlUpdate, { passive: true });
      }

      updateControls();
    };

    const initialiseAll = (scope = document) => {
      if (scope.matches?.(selector)) initialise(scope);
      scope.querySelectorAll(selector).forEach(initialise);
    };

    if (!window.tmpgHomeCarouselEventsReady) {
      window.tmpgHomeCarouselEventsReady = true;

      document.addEventListener('click', (event) => {
        const button = event.target.closest('[data-tmpg-carousel-prev], [data-tmpg-carousel-next]');
        if (!button || button.disabled) return;
        const carousel = button.closest(selector);
        if (!carousel) return;
        moveCarousel(carousel, button.hasAttribute('data-tmpg-carousel-prev') ? -1 : 1);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        const track = event.target.closest('[data-tmpg-carousel-track]');
        if (!track) return;
        const carousel = track.closest(selector);
        if (!carousel) return;
        event.preventDefault();
        moveCarousel(carousel, event.key === 'ArrowLeft' ? -1 : 1);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
    } else {
      initialiseAll();
    }

    document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
